{
  "Accessibility Menu": "ਪਹੁੰਚ ਮੇਨੂ",
  "Reset settings": "ਸੈਟਿੰਗਾਂ ਰੀਸੈਟ ਕਰੋ",
  "Close": "ਬੰਦ ਕਰੋ",
  "Content Adjustments": "ਸਮੱਗਰੀ ਸੰਸ਼ੋਧਨ",
  "Adjust Font Size": "ਫੋਂਟ ਆਕਾਰ ਅਨੁਕੂਲਿਤ ਕਰੋ",
  "Highlight Title": "ਸਿਰਲੇਖ ਹਾਈਲਾਈਟ ਕਰੋ",
  "Highlight Links": "ਲਿੰਕ ਹਾਈਲਾਈਟ ਕਰੋ",
  "Readable Font": "ਪੜ੍ਹਨਯੋਗ ਫੋਂਟ",
  "Color Adjustments": "ਰੰਗ ਸੰਸ਼ੋਧਨ",
  "Dark Contrast": "ਗੂੜ੍ਹਾ ਵਿਰੋਧ",
  "Light Contrast": "ਹਲਕਾ ਵਿਰੋਧ",
  "High Contrast": "ਉੱਚਾ ਵਿਰੋਧ",
  "High Saturation": "ਉੱਚਾ ਸੰਤ੍ਰਿਪਤੀ",
  "Low Saturation": "ਘੱਟ ਸੰਤ੍ਰਿਪਤੀ",
  "Monochrome": "ਇਕ ਰੰਗੀ",
  "Tools": "ਉਪਕਰਨ",
  "Reading Guide": "ਪੜ੍ਹਨ ਗਾਈਡ",
  "Stop Animations": "ਐਨੀਮੇਸ਼ਨ ਰੋਕੋ",
  "Big Cursor": "ਵੱਡਾ ਕਰਸਰ",
  "Increase Font Size": "ਫੋਂਟ ਆਕਾਰ ਵਧਾਓ",
  "Decrease Font Size": "ਫੋਂਟ ਆਕਾਰ ਘਟਾਓ",
  "Letter Spacing": "ਅੱਖਰਾਂ ਦੀ ਦੂਰੀ",
  "Line Height": "ਲਾਈਨ ਦੀ ਉਚਾਈ",
  "Font Weight": "ਫੋਂਟ ਭਾਰ",
  "Dyslexia Font": "ਡਿਸਲੈਕਸੀਆ ਫੋਂਟ",
  "Language": "ਭਾਸ਼ਾ",
  "Open Accessibility Menu": "ਪਹੁੰਚ ਮੇਨੂ ਖੋਲ੍ਹੋ",
  "Accessibility Profiles": "ਪਹੁੰਚ ਪ੍ਰੋਫਾਈਲ",
  "Seizure Safe Profile": "ਦਸਤਾਨੇ ਸੁਰੱਖਿਅਤ ਪ੍ਰੋਫਾਈਲ",
  "Stops animations and reduces color saturation.": "ਐਨੀਮੇਸ਼ਨ ਰੋਕਦਾ ਹੈ ਅਤੇ ਰੰਗ ਸੰਤ੍ਰਿਪਤੀ ਘਟਾਉਂਦਾ ਹੈ।",
  "Blind Profile": "ਅੰਨ੍ਹੇ ਲਈ ਪ੍ਰੋਫਾਈਲ",
  "Activates the screen reader for auditory navigation.": "ਆਡੀਟਰੀ ਨੈਵੀਗੇਸ਼ਨ ਲਈ ਸਕਰੀਨ ਰੀਡਰ ਸਰਗਰਮ ਕਰਦਾ ਹੈ।",
  "Visually Impaired Profile": "ਦ੍ਰਿਸ਼ਟੀ ਹਾਨੀ ਵਾਲਿਆਂ ਲਈ ਪ੍ਰੋਫਾਈਲ",
  "Enhances contrast and readability for low vision.": "ਘੱਟ ਦ੍ਰਿਸ਼ਟੀ ਵਾਲਿਆਂ ਲਈ ਵਿਰੋਧ ਅਤੇ ਪੜ੍ਹਨਯੋਗਤਾ ਵਧਾਉਂਦਾ ਹੈ।",
  "ADHD Friendly Profile": "ADHD ਲਈ ਮਿੱਤਰ ਪ੍ਰੋਫਾਈਲ",
  "Reduces distractions for better focus.": "ਵਧੀਆ ਧਿਆਨ ਲਈ ਧਿਆਨ ਭੰਗ ਘਟਾਉਂਦਾ ਹੈ।",
  "Cognitive & Learning Profile": "ਸਮਝਦਾਰੀ ਅਤੇ ਸਿੱਖਣ ਪ੍ਰੋਫਾਈਲ",
  "Helpful tools for reading and comprehension.": "ਪੜ੍ਹਨ ਅਤੇ ਸਮਝਣ ਲਈ ਮਦਦਗਾਰ ਉਪਕਰਨ।",
  "Motor Impaired Profile": "ਮੋਟਰ ਸਮਰੱਥਾ ਘਟਿਆ ਲੋਕਾਂ ਲਈ ਪ੍ਰੋਫਾਈਲ",
  "Optimizes the site for keyboard-only navigation.": "ਕੇਵਲ ਕੀਬੋਰਡ ਨਾਲ ਨੈਵੀਗੇਸ਼ਨ ਲਈ ਸਾਈਟ ਨੂੰ ਅਨੁਕੂਲਿਤ ਕਰਦਾ ਹੈ।",
  "Headings": "ਸਿਰਲੇਖ",
  "Landmarks": "ਲੈਂਡਮਾਰਕ",
  "Links": "ਲਿੰਕ",
  "Focus element": "ਫੋਕਸ ਤੱਤ",
  "Visit link": "ਲਿੰਕ ਤੇ ਜਾਓ"
}